import { render, staticRenderFns } from "./right-fixed-box.vue?vue&type=template&id=97d45318&scoped=true&"
import script from "./right-fixed-box.vue?vue&type=script&lang=js&"
export * from "./right-fixed-box.vue?vue&type=script&lang=js&"
import style0 from "./right-fixed-box.vue?vue&type=style&index=0&id=97d45318&prod&lang=css&"
import style1 from "./right-fixed-box.vue?vue&type=style&index=1&id=97d45318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d45318",
  null
  
)

export default component.exports